"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathJoin = void 0;
function pathJoin() {
    var path = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        path[_i] = arguments[_i];
    }
    return path
        .map(function (part, i) { return (i === 0 ? part : part.replace(/^\/+/, "")); })
        .map(function (part, i) { return (i === path.length - 1 ? part : part.replace(/\/+$/, "")); })
        .join("/");
}
exports.pathJoin = pathJoin;
//# sourceMappingURL=pathJoin.js.map